import { render } from "./NotePanel.vue?vue&type=template&id=4f098afa&lang=html"
import script from "./NotePanel.vue?vue&type=script&lang=js"
export * from "./NotePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__